import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import { AxiosError } from 'axios';
import { getErrorDetail } from 'Services/errors';
import Notify, { AlertTypes } from 'Services/notification';
import RecordsService from 'Services/records';
import CheckoutService from 'Services/checkout';
import { history, store } from 'Store';
import { setTaxSelectedAction } from 'Store/modules/tax/actions';
import { setStageAction } from 'Store/modules/validations/actions';
import { routes } from 'Constants/routes';
import {
  QueryKeys,
  RecordArchiveResponse,
  RecordType,
  ResponseArrayType,
  ResponseType,
  ResultType,
} from 'Types/common';
import { TaxReturnTypes } from './types';

export const resultSelector = (response: RecordArchiveResponse): ResultType => {
  const dataFiltered = {
    mandatory: false,
    taxReturnResult: response.satInfo.satInfoResult.amount,
    taxReturnSubType: '',
    taxReturnType:
      response.satInfo.satInfoResult.type === TaxReturnTypes.ZERO
        ? TaxReturnTypes.EQUAL
        : response.satInfo.satInfoResult.type,
    warnings: [],
    recordId: response.id,
  } as ResultType;

  return dataFiltered;
};

export const useFetchGetResultXml = (): UseQueryResult<ResultType> =>
  useQuery([QueryKeys.FETCH_GET_RESULT_XML], RecordsService.getRecordArchive, {
    select: data => resultSelector(data),
    onError: (err: AxiosError) => {
      if (err.response?.status) {
        Notify.sendNotification(getErrorDetail(err), AlertTypes.error);
        history.push(routes.DASHBOARD);
      }
    },
    refetchOnWindowFocus: false,
    refetchInterval: data => (data ? false : 500),
  });
export const useFetchGetClabeXml = (): UseQueryResult<{ clabe: string }> =>
  useQuery([QueryKeys.GET_CLABE_XML], RecordsService.getRecordArchiveClabe, {
    refetchOnWindowFocus: false,
  });

export const useSubmitUserXml = ({
  isFlexCheckout = false,
}: {
  isFlexCheckout?: boolean;
}): UseMutationResult<ResponseType<unknown>, { clabe?: string; recordId?: string }> =>
  useMutation([QueryKeys.SUBMITTED_USER_XML], RecordsService.saveClabeAndSubmit, {
    onSuccess: () => {
      if (!isFlexCheckout) {
        history.push(routes.FILING_XML);
      }
    },
  });

export const useSavePayLaterXml = (): UseMutationResult<
  ResponseType<unknown>,
  { taxYear: string; type: string }
> =>
  useMutation([QueryKeys.SAVE_PAY_LATER_XML], CheckoutService.subscribeLiteFlex, {
    onError: () => {
      history.push(routes.DASHBOARD);
    },
  });

export const useFetchGetRecord = (): UseQueryResult<ResponseArrayType<RecordType>> => {
  return useQuery([QueryKeys.GET_RECORD_XML], () => RecordsService.getRecords({ current: true }), {
    onSuccess: data => {
      const info = data?.data[0];
      const record = info?.item;
      if (record?.recordId) {
        store.dispatch(
          setTaxSelectedAction({ recordId: record.recordId, taxYear: record.taxYear })
        );
      }
      if (record?.stage) {
        store.dispatch(setStageAction(record.stage));
      }
      return data ?? null;
    },
    refetchInterval: data => (data?.data[0]?.item?.recordId ? false : 500),
  });
};
